<template>
  <leo-progress-stepper :steps="getCurrentStep" :activeStep="`${currentStep}`">
  </leo-progress-stepper>
</template>
<style>
.leo-icon {
  line-height: 0.7 !important;
}
</style>
<script>
import { mapGetters } from "vuex";
import { VueLeoProgressStepper } from "@greateasternlife/leo-progress-stepper";
export default {
  name: "Stepper",
  components: {
  "leo-progress-stepper": VueLeoProgressStepper,
  },
  props: {
    steps1: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeStep: 1,
      steps: [],
    };
  },
  mounted() {
    this.steps = this.prepareStepData();
  },
  methods: {
    prepareStepData() {
      for (let i = 0; i <= this.stepperMaxLength - 1; i++) {
        this.steps.push({
          id: `step-id-${i + 1}`,
          step: `${i + 1}`,
          isDone: false,
          activeStep: false,
          contentActive: true,
        });
      }
      return this.steps;
    },
  },
  computed: {
    ...mapGetters({
      currentStep: "user/getCurrentStep",
      isGroupSignup: "user/getCurrentStep",
      stepperMaxLength: "user/getStepperMaxLength",
    }),
    getCurrentStep() {
      if (this.currentStep) {
        this.steps.map((item, index) => {
          if (this.currentStep === index + 1) {
            item.activeStep = true;
            item.contentActive = true;
          }
          if (this.currentStep > index + 1) {
            item.isDone = true;
          }
          return item;
        });
      }
      return this.steps;
    },
  },
};
</script>
